import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ripudaman</span> from{" "}
            <span className="purple">Jaipur, Rajasthan, India</span>.
            <br />I’m currently working as a{" "}
            <span className="purple">Software Engineer</span> at{" "}
            <span className="purple">Pizone Infotech Solutions Pvt. Ltd.</span>{" "}
            in <span className="purple">Jaipur</span>.
            <br />
            <br />
            I specialize in full-stack web development with a strong command of{" "}
            <span className="purple">React.js, Node.js, Next.js,</span> and{" "}
            <span className="purple">Nest.js</span>. With hands-on experience
            in scalable web applications, I focus on building secure, efficient,
            and production-ready systems using technologies like{" "}
            <span className="purple">Sequelize ORM, MongoDB,</span> and{" "}
            <span className="purple">MySQL</span>.
            <br />
            <br />
            From developing RESTful APIs to implementing JWT authentication and
            role-based access, I enjoy solving real-world problems with clean
            architecture and a user-centric mindset.
          </p>

          <p style={{ textAlign: "justify" }}>
            Beyond the code, I am passionate about continuous learning and
            exploring:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> 🎮 Gaming
            </li>
            <li className="about-activity">
              <ImPointRight /> ✍️ Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> 🏋️‍♂️ Fitness & Gym
            </li>
            <li className="about-activity">
              <ImPointRight /> 🎧 Music
            </li>
            <li className="about-activity">
              <ImPointRight /> ✈️ Traveling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Striving to engineer solutions that not only solve problems but
            also inspire innovation and positive impact."
          </p>
          <footer className="blockquote-footer">Ripudaman</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
